/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateModifierGroupsRequestInnerAllOfModifiersInner } from './UpdateModifierGroupsRequestInnerAllOfModifiersInner';
import {
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSON,
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSONTyped,
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSON,
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSONTyped,
} from './UpdateModifierGroupsRequestInnerAllOfModifiersInner';

/**
 * 
 * @export
 * @interface UpdateModifierGroupRequest
 */
export interface UpdateModifierGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateModifierGroupRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateModifierGroupRequest
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModifierGroupRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateModifierGroupRequest
     */
    max: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateModifierGroupRequest
     */
    min?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModifierGroupRequest
     */
    allowRepeat?: boolean;
    /**
     * 
     * @type {Array<UpdateModifierGroupsRequestInnerAllOfModifiersInner>}
     * @memberof UpdateModifierGroupRequest
     */
    modifiers: Array<UpdateModifierGroupsRequestInnerAllOfModifiersInner>;
}

/**
 * Check if a given object implements the UpdateModifierGroupRequest interface.
 */
export function instanceOfUpdateModifierGroupRequest(value: object): value is UpdateModifierGroupRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('modifiers' in value) || value['modifiers'] === undefined) return false;
    return true;
}

export function UpdateModifierGroupRequestFromJSON(json: any): UpdateModifierGroupRequest {
    return UpdateModifierGroupRequestFromJSONTyped(json, false);
}

export function UpdateModifierGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateModifierGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'max': json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'allowRepeat': json['allowRepeat'] == null ? undefined : json['allowRepeat'],
        'modifiers': ((json['modifiers'] as Array<any>).map(UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSON)),
    };
}

export function UpdateModifierGroupRequestToJSON(json: any): UpdateModifierGroupRequest {
    return UpdateModifierGroupRequestToJSONTyped(json, false);
}

export function UpdateModifierGroupRequestToJSONTyped(value?: UpdateModifierGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'max': value['max'],
        'min': value['min'],
        'allowRepeat': value['allowRepeat'],
        'modifiers': ((value['modifiers'] as Array<any>).map(UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSON)),
    };
}

